import Controller from "@ember/controller";
import { once } from "@ember/runloop";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import ENV from "glesys-controlpanel/config/environment";
import { allRouteParams } from "glesys-controlpanel/utils/url";

export default class ApplicationController extends Controller {
  queryParams = ["locale", "utm_source", "utm_medium", "utm_content", "utm_campaign"];

  _locale;
  get locale() {
    return this._locale;
  }

  set locale(value) {
    this._locale = value;
    if (this.locale) {
      this.intl.setLocaleIfValid(this.locale);
      once(this, this.clearParams);
    }
  }

  _utm_source;
  get utm_source() {
    return this._utm_source;
  }

  set utm_source(value) {
    this._utm_source = value;

    if (this.utm_source) {
      this.current.set("utm", {
        source: this.utm_source,
        medium: this.utm_medium,
        content: this.utm_content,
        campaign: this.utm_campaign,
      });
      once(this, this.clearParams);
    }
  }

  @tracked utm_medium = null;
  @tracked utm_content = null;
  @tracked utm_campaign = null;

  @service current;
  @service intl;
  @service updateNotify;
  @service notification;
  @service router;

  constructor() {
    super(...arguments);
    this.updateNotify.check();
  }

  get environment() {
    let { environment } = ENV;
    return environment !== "production" ? `(${environment})` : "";
  }

  get showDevtools() {
    return ENV.devtools;
  }

  get pageTitle() {
    return `${this.environment} Glesys Cloud`.trim();
  }

  clearParams() {
    let route = this.router.currentRoute;

    let params = allRouteParams(route);

    this.router.replaceWith(route.name, ...params, {
      queryParams: {
        locale: null,
        utm_source: null,
        utm_medium: null,
        utm_content: null,
        utm_campaign: null,
      },
    });
  }
}
